import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { Input } from 'src/domains/common/components/input/input';
import { Switch } from 'src/domains/common/components/switch/switch';
import { PromotionDetails } from 'src/components/CustomersBar/CustomerTab/PromotionHistory/PromotionDetails/PromotionDetails';
import { LoadingV2 } from 'src/components/Loading/LoadingV2';
import { FilterMenu } from 'src/domains/casino/webview/bonus-engine/campaign-list/filters/Filters';
import { BonusWinningsModel } from 'src/domains/casino/state/AppCasino/store/campaign-store/BonusWinningsModel';
import { BonusBalanceNavigationState } from './BonusBalanceNavigation.state';
import { BonusWinningsCard } from 'src/components/CustomersBar/CustomerTab/PromotionHistory/BonusWinningsCard';

export interface BonusBalanceTabPropsType {
    bonusWinningsModels: () => Array<BonusWinningsModel> | 'loading';
    userId: number;
}

export const BonusBalanceTab = observer('BonusBalanceTab', (props: BonusBalanceTabPropsType) => {
    const [navigationState] = useState(() => new BonusBalanceNavigationState(props.bonusWinningsModels));
    const isDetailsView = navigationState.activeModel !== null;

    if (navigationState.bonusesForVew === 'loading') {
        return (
            <LoadingV2
                dataTest=''
                title='Loading bonuses...'
            />
        );
    }

    return (
        <>
            <div className='flex flex-row items-center justify-between'>
                <Switch
                    labelPosition='right'
                    checked={navigationState.hideExpired}
                    onChange={navigationState.onToggleExpired}
                    label='Hide Expired'
                />
                <div className='flex items-center'>
                    <Input
                        placeholder='Search'
                        formInputState={navigationState.searchInput}
                        errors={[]}
                        className='w-[251px] mr-4'
                    />
                    <FilterMenu
                        campaignListState={navigationState}
                        submenuPosition='left'
                    />
                </div>
            </div>

            <div className='grid grid-cols-12 gap-3 min-h-[220px]'>
                <div className={`${isDetailsView ? 'col-span-3' : 'col-span-12 grid grid-cols-4 gap-3'}`}>
                    {navigationState.bonusesForVew.map((bonusWinningsModel) => (
                        <BonusWinningsCard
                            key={bonusWinningsModel.id}
                            userId={props.userId}
                            bonusWinningsModel={bonusWinningsModel}
                            state={navigationState}
                        />
                    ))}
                </div>
                {isDetailsView && (
                    <div className='col-span-9'>
                        <PromotionDetails
                            userId={props.userId}
                            bonusModel={navigationState.activeModel}
                        />
                    </div>
                )}
            </div>
        </>
    );
});
